import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { IntegrationStatus } from 'graphqlAPI'

const translationPrefix = `enumerations.integration_status`

export const useIntegrationStatus = () => {
  const { t } = useTranslation()

  const integrationStatusTranslations = useMemo(
    (): Record<IntegrationStatus, string> => ({
      [IntegrationStatus.EnrolledInCourse]: t(
        `${translationPrefix}.enrolled_in_course`
      ),
      [IntegrationStatus.EnrolledInProgram]: t(
        `${translationPrefix}.enrolled_in_program`
      ),
      [IntegrationStatus.InvitedToCourse]: t(
        `${translationPrefix}.invited_to_course`
      ),
      [IntegrationStatus.InvitedToProgram]: t(
        `${translationPrefix}.invited_to_program`
      ),
      [IntegrationStatus.NoAccount]: t(`${translationPrefix}.no_account`),
      [IntegrationStatus.Pending]: t(`${translationPrefix}.pending`),
      [IntegrationStatus.UncontrolledError]: t(
        `${translationPrefix}.uncontrolled_error`
      ),
    }),
    [t]
  )

  return integrationStatusTranslations
}
